import { render, staticRenderFns } from "./ShipmentsTableComponent.vue?vue&type=template&id=7ccc7374&scoped=true"
import script from "./ShipmentsTableComponent.vue?vue&type=script&lang=js"
export * from "./ShipmentsTableComponent.vue?vue&type=script&lang=js"
import style0 from "./ShipmentsTableComponent.vue?vue&type=style&index=0&id=7ccc7374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccc7374",
  null
  
)

export default component.exports